import { keyBy } from 'lodash';

import {
  GET_LANGUAGES,
  GET_LANGUAGES_FAILED,
  GET_LANGUAGES_SUCCESS,
} from "../actions/languageManagement.action";

const INITIAL_STATE = {
  languages: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function languageReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LANGUAGES:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_LANGUAGES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        languages: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_LANGUAGES_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
